import React from "react";
import { render, screen } from "@testing-library/react";

import { FloatingChatWidget } from "./FloatingChatWidget";

jest.mock("./ChatPanel", () => ({
  ChatPanel: (props: { canvasId?: string }) => (
    <div data-testid="chat-panel" data-canvas-id={props.canvasId} />
  ),
}));
let mockAgentVisible = true;
jest.mock("../../hooks/useMyVaultAgentVisibility", () => ({
  useMyVaultAgentVisibility: () => mockAgentVisible,
}));

describe("FloatingChatWidget panel sizing", () => {
  beforeEach(() => {
    mockAgentVisible = true;
    localStorage.setItem("myvault-chat-open-ws1", "true");
  });

  it("uses the viewport width minus margins below the sm breakpoint, 520px above", () => {
    render(<FloatingChatWidget workspaceId="ws1" />);
    expect(screen.getByTestId("chat-panel")).toBeTruthy();
    const css = Array.from(document.styleSheets)
      .flatMap((sheet) => Array.from(sheet.cssRules))
      .map((rule) => rule.cssText)
      .join("\n");
    expect(css).toContain("width: calc(100vw - 32px)");
    expect(css).toContain("width: 520px");
  });

  it("keeps the open panel below MyVault page toolbars", () => {
    render(<FloatingChatWidget workspaceId="ws1" />);
    const css = Array.from(document.styleSheets)
      .flatMap((sheet) => Array.from(sheet.cssRules))
      .map((rule) => rule.cssText)
      .join("\n");

    expect(css).toContain("top: max(120px, calc(100vh - 780px))");
    expect(css).toContain("bottom: 80px");
    expect(css).toContain("height: min(700px, calc(100vh - 200px))");
    expect(css).toContain("min-height: 0;");
  });

  it("allows a server-authorized canvas assistant on the runtime route", () => {
    mockAgentVisible = false;
    localStorage.setItem("myvault-chat-open-ws1-canvas-canvas-7", "true");

    render(
      <FloatingChatWidget
        workspaceId="ws1"
        canvasId="canvas-7"
        allowCanvasRuntime
      />,
    );

    expect(
      screen.getByTestId("chat-panel").getAttribute("data-canvas-id"),
    ).toBe("canvas-7");
  });

  it("keeps the canvas assistant hidden without the server-authorized runtime prop", () => {
    mockAgentVisible = false;
    localStorage.setItem("myvault-chat-open-ws1-canvas-canvas-7", "true");

    render(<FloatingChatWidget workspaceId="ws1" canvasId="canvas-7" />);

    expect(screen.queryByTestId("chat-panel")).toBeNull();
  });
});
